// @flow
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { useViewport } from 'components/templates/viewportProvider';
import React, { useEffect, useState } from 'react';
import { findIndex } from 'lodash';
import Slider from 'react-slick';
import { ImageGalleryItemMobile } from 'components/atoms/imageGalleryItemMobile';
import type { GalleryImageType } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  images: Array<GalleryImageType>,
};

export const ImageGalleryMobile = (props: Props) => {
  const { height } = useViewport();
  const [imageForOverlay, setImageForOverlay] = useState(null);

  const { images, type = '' } = props;

  if (!images || images.length === 0) {
    return null;
  }
  const isRestaurantGallery = type === 'restaurant';
  const onImageClick = (image: GalleryImageType) => {
    // TODO: Fix this after Overlay is refactored
    // setImageForOverlay(image);
  };

  const clearImageForOverlay = () => {
    setImageForOverlay(null);
  };

  const settings = {
    className: 'slider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
  };

  return (
    <div className={'image-gallery-mobile'} style={{ height }}>
      <h3>Gallery</h3>
      <Slider {...settings}>
        {images.map((item: GalleryImageType) => {
          return (
            <ImageGalleryItemMobile
              imageUrl={item.mediumMobileImageUrl}
              caption={item.caption}
              key={item.id}
              onClick={onImageClick}
            />
          );
        })}
      </Slider>
      {imageForOverlay && (
        <OverlayPortal>
          <OverlayModal
            activeImage={imageForOverlay}
            images={images}
            theme={'dark-theme'}
            type={'image-overlay'}
            onClosePress={clearImageForOverlay}
            breadcrumbList={[
              {
                breadcrumbName: 'Gallery',
                breadcrumbLink: '#',
              },
            ]}
          />
        </OverlayPortal>
      )}
    </div>
  );
};
